module.exports = __webpack_public_path__ + "assets/images/avatar_front_shadow.64452cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/avatar_front_shadow.png
// module id = 679
// module chunks = 1